<div class="preserve-whitespace">
{{fieldContent}}
</div>